// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormVisual.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormVisual component
 */
!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var TinyMCE = require('share/components/controls/TinyMCE/Izenda.TinyMCE');
  var constants = require('logic/data/Izenda.ReportPartFormConstants');
  var ReportPartFieldPropsContainerSchema = require('modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.ReportPartFieldPropsContainerSchema');
  var PropertiesEditorUtils = require('share/utils/Izenda.PropertiesEditorUtils');

  var EmbedReportPopup = require('./Izenda.EmbedReportPopup');
  var ReportPartFormSpellCheck = require('./Izenda.ReportPartFormSpellCheck');
  var FieldSelectionPopup = require('./Izenda.FieldSelectionPopup');
  var ReportPartFormDnD = require('./Izenda.ReportPartFormDnD');
  var ReportPartFormWrapper = ReportPartFormDnD(require('./Izenda.ReportPartFormWrapper'));
  var reportBodyConstants = require('logic/data/Izenda.ReportBodyConstants');
  const { trim, find, isNil, merge, getOr, flow } = require('lodash/fp');
  var ReportPartFormVisual = React.createClass({
    propTypes: {
      reportPart: React.PropTypes.object
    },

    handleEditorChange: function(e) {
      var store = this.props.store;
      var reportPart = this.props.reportPart;
      var reportPartContent = reportPart.reportPartContent;
      var content = e.target.getContent({ no_events: true });

      reportPartContent.setHTMLContent(content, reportPart);
      store.model.markDirty();
    },

    handleClick: function(event) {
      var props = this.props;
      var selectedElement = event.target;
      var reportPart = this.props.reportPart;

      if (selectedElement.className === 'icon-cancel') {
        let fieldName = trim(selectedElement.parentElement.textContent);

        if (fieldName === reportBodyConstants.FIELD_HIDDEN_LABEL) {
          let fieldNameAttr = $izenda(selectedElement.parentElement).attr('field-name');
          let matches = fieldNameAttr.match(/\[(.*?)\]/g);
          let lastMatched = matches[matches.length - 1].replace('[', '').replace(']', '');
          fieldName = lastMatched;
        }

        var fieldDetail = find({ fieldName: fieldName }, reportPart.fieldCollection);

        if (fieldDetail) {
          var insideColumn = !flow(find({ fieldNameAlias: fieldName }), isNil)(
            reportPart.reportPartContent.columns.elements
          );

          reportPart.removeFieldFromContainer(
            insideColumn ? reportPart.reportPartContent.columns : reportPart.reportPartContent.separators,
            fieldDetail
          );
          reportPart.reportPartContent.editorControl.removeElement(selectedElement.parentElement);
        }
        return;
      }

      switch (selectedElement.tagName) {
        case 'FIELD':
          var fieldNameMapping = trim(selectedElement.textContent);
          if (fieldNameMapping === reportBodyConstants.FIELD_HIDDEN_LABEL) {
            let fieldNameAttr = $izenda(selectedElement).attr('field-name');
            let matches = fieldNameAttr.match(/\[(.*?)\]/g);
            let lastMatched = matches[matches.length - 1].replace('[', '').replace(']', '');
            fieldNameMapping = lastMatched;
          }

          // The issue comes from Microsoft Edge.
          // After the TinyMCT re-init, we could not access to data of old Iframe.
          // The solution: Delete this property to break the reference to old iframe.
          delete reportPart.reportPartContent.selectedFieldElement;
          reportPart.reportPartContent.selectedFieldElement = selectedElement;
          var fieldMapping = find({ fieldName: fieldNameMapping }, reportPart.fieldCollection);

          if (!fieldMapping) {
            return;
          }
          var fieldData = merge(props, {
            itemData: fieldMapping,
            fieldContainerDetails: reportPart.reportPartContent.columns,
            beforeShowProps: function() {
              reportPart.setConfigField(fieldMapping);
            }
          });
          var propsEditors = [{ name: 'fieldProps', getDefinedSchema: ReportPartFieldPropsContainerSchema }];

          PropertiesEditorUtils.switchToEditor(this, fieldData, propsEditors);
          break;

        case 'EMBEDDED-REPORT':
          this.props.openPopup(EmbedReportPopup, {
            reportPartContent: reportPart.reportPartContent,
            embeddedReportDOM: $izenda(event.target)
          });
          break;
        case 'SUBTOTAL':
          this.props.openPopup(FieldSelectionPopup, {
            store: this.props.store,
            reportPartContent: reportPart.reportPartContent,
            isSubTotal: true,
            selectedElement: this.getSelectionNode()
          });
          break;
        case 'GRANDTOTAL':
          this.props.openPopup(FieldSelectionPopup, {
            store: this.props.store,
            reportPartContent: reportPart.reportPartContent,
            selectedElement: this.getSelectionNode()
          });
          break;
      }
    },

    handleNodeChange: function(event) {
      var content = this.props.reportPart.reportPartContent || {};
      var properties = content.properties;

      if (event.element.dir === 'ltr') {
        properties.mceDirectionLTR = true;
        properties.mceDirectionRTL = false;
      } else if (event.element.dir === 'rtl') {
        properties.mceDirectionRTL = true;
        properties.mceDirectionLTR = false;
      } else {
        properties.mceDirectionRTL = false;
        properties.mceDirectionLTR = false;
      }

      var isSelectedCell = content.getEditorControl().isSelectedCell;
      content.isSelectedCell = isSelectedCell && isSelectedCell();
    },

    handleFocus: function() {
      var content = this.props.reportPart.reportPartContent || {};
      content.isActiveForEdit = true;
    },

    componentDidMount: function() {
      this.setEditorControl();
    },

    // Update the new editor control
    componentDidUpdate: function() {
      this.setEditorControl();
    },

    setEditorControl: function() {
      var content = this.props.reportPart.reportPartContent;
      var editor = this.domEditor || {};
      content.setEditorControl(editor);
    },

    getSelectionNode: function() {
      var controlEditor = getOr({}, 'tinymce', this.domEditor);
      var controlEditorId = getOr({}, 'id', this.domEditor);
      var tinyMCEControl = controlEditor.get && controlEditor.get(controlEditorId);
      return tinyMCEControl && tinyMCEControl.selection.getNode();
    },

    handleFormatChange: function(value, state) {
      var content = this.props.reportPart.reportPartContent;
      var properties = content.properties;

      for (var key in properties.format) {
        if (properties.format[key].hasOwnProperty(value)) {
          properties.format[key][value] = state;
        }
      }
    },

    handleSpellCheck: function(content, startRange, endRange) {
      var reportPart = this.props.reportPart;
      var reportPartContent = reportPart.reportPartContent;
      var htmlContent = reportPartContent.htmlContent;

      var applyChangeContent = function(value) {
        var startIndex = 0;
        var newContent = htmlContent.substring(startIndex, startRange) + value + htmlContent.substring(endRange);
        reportPartContent.setHTMLContent(newContent, reportPart);
        reportPartContent.editorControl.insertContent(value);
      }.bind(this);

      this.props.openPopup(ReportPartFormSpellCheck, {
        onAcceptChange: applyChangeContent.bind(this),
        content: content
      });
    },

    setDom: function(domNode) {
      this.domEditor = domNode;
    },

    render: function() {
      var startIndex = 0;
      var reportPart = this.props.reportPart || {};
      var reportPartContent = reportPart.reportPartContent;
      reportPartContent.convertRepeaterTag(startIndex, constants.TAB_VISUAL.key);
      var visualChars = getOr(false, 'properties.mceVisualChars', reportPartContent);
      var config = {
        paste_as_text: getOr(false, 'properties.pasteAsText', reportPartContent),
        visual: getOr(true, 'properties.mceToggleVisualAid', reportPartContent)
      };
      var classes = classnames({
        'report-part-form-visual': true
      });
      var id = reportPartContent.formState.id;
      return (
        <div className={classes}>
          <TinyMCE
            ref={this.setDom}
            key={id}
            id={id}
            config={config}
            visualChars={visualChars}
            content={reportPartContent.htmlContent}
            onChange={this.handleEditorChange}
            onClick={this.handleClick}
            onNodeChange={this.handleNodeChange}
            onFocus={this.handleFocus}
            onFormatChange={this.handleFormatChange}
            onSpellCheck={this.handleSpellCheck}
          />

          {/* Add layout for drop field item*/}
          <ReportPartFormWrapper {...this.props} />
        </div>
      );
    }
  });

  module.exports = connect()(ReportPartFormVisual);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.ReportPartFormVisual.jsx